import { render, staticRenderFns } from "./proceso.vue?vue&type=template&id=744f4a50&scoped=true&"
import script from "./proceso.component.ts?vue&type=script&lang=ts&"
export * from "./proceso.component.ts?vue&type=script&lang=ts&"
import style0 from "./proceso.vue?vue&type=style&index=0&id=744f4a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f4a50",
  null
  
)

export default component.exports